import { sdk } from 'src/utilities/sdk';
import { IAsyncTaskResponse } from 'src/utilities/useAsyncTask';

export interface ManageMealCreditGroupsApiProps {
  corpId: string;
  mealCreditId: string;
  updatedGroupBudgets: {
    [id: string]: number;
  };
}

export const updateBudgetsForMealCredit = async ({
  corpId,
  mealCreditId,
  updatedGroupBudgets,
}: ManageMealCreditGroupsApiProps): Promise<IAsyncTaskResponse> => {
  return sdk.http.post(`/corp-admin/${corpId}/events/${mealCreditId}/budget`, {
    updated_group_budgets: updatedGroupBudgets,
  });
};
